<ds-themed-search [trackStatistics]="true"></ds-themed-search>
